export default {
  POST_MESSAGE: 'POST_MESSAGE',
  GET_MESSAGE: 'GET_MESSAGE',
  CLEAR_MESSAGE: 'CLEAR_MESSAGE',
};
